import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { Oval } from "react-loading-icons";
import {
  keepMaftir2,
  sendMaftir2,
  updateMaftir2,
  removeMaftir2,
  keepParasha2,
  sendParasha2,
  updateParasha2,
  removeParasha2,
  sendEmail,
  keepName,
  loadUsers,
} from "../store/actions/userAction";
//import "./styles.css";
import ReactCalendar from "react-calendar";
import styled from "styled-components";
import Hebcal, { HDate } from "hebcal";
import gematriya from "gematriya";
import { Button, Input } from "reactstrap";
import { TextField } from "@material-ui/core";
import moment from "moment";
import { SITE_ADRESS, SENDGRID_MAILFROM1 } from "../config";
export function ReadReservation() {
  const dispatch = useDispatch();
  const [openFlag, setOpenFlag] = useState(parseInt(0));
  const [data, setData] = useState([]);
  const [dateU, setDateU] = useState("");
  const [Ev, setEv] = useState("");
  const [Evs, setEvs] = useState([]);
  const [bol, setBol] = useState(false);
  const [bol2, setBol2] = useState(false);
  const [haftara, setHaftara] = useState("");

  //let bol = false;
  const [focusIdx, setFocusIdx] = useState(0);
  const [costumerLastName, setCostumerLastName] = useState("");
  const [costumerDetails, setCostumerDetails] = useState("");
  const loggedInUser = useSelector((state) => state.userReducer.loggedInUser);
  const users = useSelector((state) => state.userReducer.users);
  const isManagerOrAdmin =
    loggedInUser && (loggedInUser.isManager || loggedInUser.isAdmin);

  const isActiveReservation = (ev) =>
    ev && (ev.status === 1 || ev.status === 2);
  // setOpenFlag(0);
  useEffect(async () => {
    await dispatch(loadUsers());
    // setOpenFlag(0);
  }, [Ev]);
  useEffect(() => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  }, [openFlag]);
  function addMonths(date, months) {
    var d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() != d) {
      date.setDate(0);
    }
    return date;
  }
  const clickParasha = async () => {
    if (openFlag === 2) {
      setOpenFlag(0);
      setBol(false);
      setBol2(false);
    } else {
      setData(await keepParasha2());
      //console.log("data", data);
      setOpenFlag(2);
      setBol(false);
      setBol2(false);
    }
  };
  const clickMaftir = async () => {
    if (openFlag === 1) {
      setOpenFlag(0);
      setBol(false);
      setBol2(false);
    } else {
      setData(await keepMaftir2());
      //console.log("data", data);
      setOpenFlag(1);
      setBol(false);
      setBol2(false);
    }
  };
  const Calendar = styled(ReactCalendar)`
    width: 70%;
    margin: auto;

    text-align: center;

    abbr {
      color: rgb(0, 0, 0);
    }
    .react-calendar__month-view__weekdays__weekday {
      text-align: center;
      background: rgb(125, 125, 66);
    }
    .react-calendar__navigation__label {
      height: 40px;
    }
    .react-calendar__navigation__arrow.react-calendar__navigation__prev2-button {
      width: 20px;
    }
    .react-calendar__navigation__arrow.react-calendar__navigation__prev-button {
      width: 30px;
    }
    .react-calendar__navigation__arrow.react-calendar__navigation__next2-button {
      width: 20px;
    }
    .react-calendar__navigation__arrow.react-calendar__navigation__next-button {
      width: 30px;
    }
    .react-calendar__month-view {
      .react-calendar__tile.react-calendar__month-view__days__day.react-calendar__month-view__days__day--neighboringMonth {
        opacity: 0.3;
      }
      .free {
        background-color: green;
      }
      .week {
        background-color: white;
      }
      .react-calendar__tile--active {
        border: 2px solid blue;
        z-index: 100;
      }
      .busy {
        background-color: red;
      }
      .onAttent {
        background-color: yellow;
      }
      .react-calendar__tile {
        height: 50px;
        position: relative;

        &--now {
          border: 2px solid red;
          z-index: 100;
        }

        abbr {
          display: none;
          font-size: 1em;
        }

        .tile {
          &__hdate {
            position: absolute;
            top: 0;
            right: 0;
          }

          &__daf {
            font-size: 1.5em;
          }
        }
      }
    }
  `;

  const defTileClassName = ({ date }) => {
    if (date.getDay() !== 6) return "week";

    const formattedDate = moment(date).format("DD/MM/YYYY");
    const demandesDuShabbat = data.filter((ev) => ev.date === formattedDate);

    if (openFlag === 2) {
      const demandesActives = demandesDuShabbat.filter(isActiveReservation);
      const hasPending = demandesActives.some((ev) => ev.status === 2);
      const hasAccepted = demandesActives.some((ev) => ev.status === 1);

      if (hasPending) return "onAttent";
      if (hasAccepted) return "busy";
      return "free";
    }

    let a = 0;

    demandesDuShabbat.map((ev) => {
      if (ev.status === 1) a = 1;
      else if (ev.status === 2) a = 2;
    });

    if (a === 1) return "busy";
    if (a === 2) return "onAttent";
    return "free";
  };
  const checkDate = (newDate) => {
    setBol(false);
    setBol2(false);
    setEv("");
    setEvs([]);
    setCostumerLastName("");
    setCostumerDetails("");
    setDateU(newDate);
    setHaftara(
      Hebcal.HDate(newDate).setLocation(32.0787, 34.8483).getSedra("h"),
    );

    if (newDate.getDay() === 6) {
      const formattedDate = moment(newDate).format("DD/MM/YYYY");
      const demandesDuShabbat = data.filter((ev) => ev.date === formattedDate);

      setBol(true);

      if (openFlag === 2) {
        setEvs(demandesDuShabbat);
        setBol2(true);
      } else {
        setEv(demandesDuShabbat[0] || "");
      }
    }
  };
  const submit = async () => {
    console.log("costumerLastName", costumerLastName);
    if (!costumerLastName) {
      alert("merci d'indiquer le nom du lecteur");
    } else {
      if (openFlag === 1) {
        const newobj = {
          submiterId: loggedInUser._id,
          submiterName: loggedInUser.firstName + " " + loggedInUser.lastName,
          reader: costumerLastName,
          date: moment(dateU).format("DD/MM/YYYY"),
          status: 2,
        };
        const savedMaftir = await sendMaftir2(newobj);
        setData([...data, savedMaftir]);
        sendEmail({
          to: SENDGRID_MAILFROM1,
          subject: "demande de lecture de Haftara",
          text:
            loggedInUser.firstName +
            " " +
            loggedInUser.lastName +
            " a demandé une lecture de la haftara de " +
            haftara +
            " le " +
            moment(dateU).format("DD/MM/YYYY") +
            " , merci de valider ou non",
        });
        sendEmail({
          to: loggedInUser.email,
          subject: "demande de lecture de Hafara",
          text:
            "bonjour " +
            loggedInUser.firstName +
            " " +
            loggedInUser.lastName +
            " votre demande de lecture de Haftara du shabbat de " +
            haftara +
            " le " +
            moment(dateU).format("DD/MM/YYYY") +
            " a bien été enregistrée , vous receverez prochainnement un mail de validation ou refus du gestionnaire",
        });
        setBol2(false);
        setBol(false);
      }
      if (openFlag === 2) {
        const demandesActives = Evs.filter(isActiveReservation);
        const utilisateurADejaDemande =
          !isManagerOrAdmin &&
          demandesActives.some((ev) => ev.submiterId === loggedInUser._id);
        const toutDejaDemande = demandesActives.some(
          (ev) => ev.details === "Tout",
        );
        const monteeDejaDemandee =
          costumerDetails !== "Tout" &&
          demandesActives.some((ev) => ev.details === costumerDetails);
        if (!costumerDetails) {
          alert("merci de choisir une montée");
        } else if (demandesActives.length >= 3) {
          alert("le nombre maximum de demandes est atteint");
        } else if (utilisateurADejaDemande) {
          alert("vous avez déjà une demande pour ce shabbat");
        } else if (toutDejaDemande) {
          alert("une demande complète existe déjà pour ce shabbat");
        } else if (monteeDejaDemandee) {
          alert("cette montée est déjà demandée pour ce shabbat");
        } else {
          const newobj = {
            submiterId: loggedInUser._id,
            submiterName: loggedInUser.firstName + " " + loggedInUser.lastName,
            reader: costumerLastName,
            date: moment(dateU).format("DD/MM/YYYY"),
            details: costumerDetails,
            status: 2,
          };
          const savedParasha = await sendParasha2(newobj);

          const newData = [...data, savedParasha];
          const newEvs = [...Evs, savedParasha];

          setData(newData);
          setEvs(newEvs);
          sendEmail({
            to: SENDGRID_MAILFROM1,
            subject: "demande de lecture de Parasha",
            text:
              loggedInUser.firstName +
              " " +
              loggedInUser.lastName +
              " a demandé une lecture de la Parasha de " +
              haftara +
              " le " +
              moment(dateU).format("DD/MM/YYYY") +
              " , merci de valider ou non",
          });
          sendEmail({
            to: loggedInUser.email,
            subject: "demande de lecture de Parasha",
            text:
              "bonjour " +
              loggedInUser.firstName +
              " " +
              loggedInUser.lastName +
              " votre demande de lecture de Parasha du shabbat de " +
              haftara +
              " le " +
              moment(dateU).format("DD/MM/YYYY") +
              " a bien été enregistrée , vous receverez prochainnement un mail de validation ou refus du gestionnaire",
          });
          setCostumerLastName("");
          setCostumerDetails("");
          setBol2(true);
          setBol(true);
        }
      }
    }
  };

  const accept = async (demande) => {
    const selectedEv =
      demande ||
      data.find((el) => el.date === moment(dateU).format("DD/MM/YYYY"));

    if (!selectedEv) return;

    if (openFlag === 1) {
      const newobj = {
        _id: selectedEv._id,
        submiterId: selectedEv.submiterId,
        submiterName: selectedEv.submiterName,
        reader: selectedEv.reader,
        date: selectedEv.date,
        status: 1,
      };

      users.map((util) => {
        if (util._id === selectedEv.submiterId) {
          sendEmail({
            to: util.email,
            subject: "votre demande de lecture de Haftara",
            text:
              "bonjour " +
              selectedEv.submiterName +
              " votre demande de lecture de Haftara le " +
              selectedEv.date +
              " a été validé",
          });
        }
      });

      const savedMaftir = await updateMaftir2(newobj);
      const newData = data.map((ev) =>
        ev._id === selectedEv._id ? savedMaftir : ev,
      );
      setData(newData);
      setEv(savedMaftir);
      setBol2(false);
      setBol(false);
    } else {
      const newobj = {
        _id: selectedEv._id,
        submiterId: selectedEv.submiterId,
        submiterName: selectedEv.submiterName,
        reader: selectedEv.reader,
        date: selectedEv.date,
        details: selectedEv.details,
        status: 1,
      };

      users.map((util) => {
        if (util._id === selectedEv.submiterId) {
          sendEmail({
            to: util.email,
            subject: "votre demande de lecture de Parasha",
            text:
              "bonjour " +
              selectedEv.submiterName +
              " votre demande de lecture de Parasha le " +
              selectedEv.date +
              " a été validé",
          });
        }
      });

      const savedParasha = await updateParasha2(newobj);
      setData(
        data.map((ev) => (ev._id === selectedEv._id ? savedParasha : ev)),
      );
      setEvs(Evs.map((ev) => (ev._id === selectedEv._id ? savedParasha : ev)));
      setBol2(true);
      setBol(true);
    }
  };

  const deleteU = async (demande) => {
    const selectedEv =
      demande ||
      data.find((el) => el.date === moment(dateU).format("DD/MM/YYYY"));

    if (!selectedEv) return;

    if (openFlag === 1) {
      users.map((util) => {
        if (util._id === selectedEv.submiterId) {
          sendEmail({
            to: util.email,
            subject: "votre demande de lecture de Haftara",
            text:
              "bonjour " +
              selectedEv.submiterName +
              " votre demande de lecture de Haftara le " +
              selectedEv.date +
              " a été annulé",
          });
        }
      });

      await removeMaftir2(selectedEv._id);
      setData(data.filter((ev) => ev._id !== selectedEv._id));
      setEv("");
      setBol2(false);
      setBol(false);
    } else {
      users.map((util) => {
        if (util._id === selectedEv.submiterId) {
          sendEmail({
            to: util.email,
            subject: "votre demande de lecture de Parasha",
            text:
              "bonjour " +
              selectedEv.submiterName +
              " votre demande de lecture de Parasha le " +
              selectedEv.date +
              " a été annulé",
          });
        }
      });

      await removeParasha2(selectedEv._id);
      setData(data.filter((ev) => ev._id !== selectedEv._id));
      setEvs(Evs.filter((ev) => ev._id !== selectedEv._id));
      setBol2(true);
      setBol(true);
    }
  };

  const onChangeFocus = (ev) => {
    const { name } = ev.target;
    // console.log(ev);

    setFocusIdx(1);
  };
  const onHandleInputChange = (ev) => {
    const { name, value } = ev.target;
    //  console.log(name, value);

    switch (name) {
      case "costumerLastName":
        setCostumerLastName(value);
        break;
      case "costumerDetails":
        setCostumerDetails(value);
        break;

      default:
        break;
    }
  };
  const DateTile = ({ activeStartDate, date, view }) => {
    //Hebcal.HDate.prototype.setLocation(32.083, 34.766);
    const hDate = Hebcal.HDate(date).setLocation(32.0787, 34.8483);
    // console.log(gematriya(hDate.getDate()));
    hDate.diaspora = false; // ⚠️ clé essentielle en disapora
    const daf = hDate.dafyomi();
    const title =
      date.toDateString().slice(3) + "\n" + hDate.toString("h") + "\n" + daf;

    // const gDate = date.getDate();

    return (
      view === "month" && (
        <div title={title}>
          <div
            css={`
              text-align: center;
            `}
          >
            {date.getDate()} &middot;
            {gematriya(hDate.getDate())}
          </div>
          <div className="tile__daf">
            {date.getDay() === 6 && hDate.isSedra() ? (
              hDate.getSedra("h")
            ) : (
              <>&nbsp;</>
            )}
          </div>
          <div>
            {date.getDay() === 5 ? (
              hDate.candleLighting().toLocaleTimeString()
            ) : // <>&nbsp;</>
            date.getDay() === 6 && hDate.isSedra() ? (
              hDate.getSedra("h")
            ) : (
              <>&nbsp;</>
            )}
          </div>
        </div>
      )
    );
  };
  const demandesActivesParasha = Evs.filter(isActiveReservation);
  const monteesDejaDemandees = demandesActivesParasha.map((ev) => ev.details);
  const toutDejaDemande = monteesDejaDemandees.includes("Tout");

  const utilisateurADejaDemandeParasha =
    !isManagerOrAdmin &&
    demandesActivesParasha.some((ev) => ev.submiterId === loggedInUser?._id);

  const peutFaireDemandeParasha =
    openFlag === 2 &&
    demandesActivesParasha.length < 3 &&
    !utilisateurADejaDemandeParasha &&
    !toutDejaDemande;

  const isMonteeDisabled = (montee) => monteesDejaDemandees.includes(montee);

  const getStatusLabel = (status) => {
    if (status === 1) return "Acceptée";
    if (status === 2) return "En attente";
    return "";
  };
  //function App() {
  if (!loggedInUser || !loggedInUser.isApprouved)
    return (
      <div>
        <Oval className="oval" stroke="#06BCEE" fill="#06BCEE" />;
        <h3>
          {" "}
          vous n'avez pas encore été approuvé par le responsable de
          l'application, patience ...{" "}
        </h3>
      </div>
    );
  return (
    <div>
      <div>
        {openFlag !== 2 && (
          <button className="btn animation-on-hover" onClick={clickMaftir}>
            reserver une Haftara
          </button>
        )}
        {openFlag !== 1 && (
          <button className="btn animation-on-hover" onClick={clickParasha}>
            reserver une lecture de Parasha
          </button>
        )}
      </div>
      <div>
        {bol &&
          openFlag === 1 &&
          (bol2 ? (
            <div>
              <p>
                <br></br>
              </p>
              <TextField
                id="outlined-read-only-input"
                label="Demandeur"
                defaultValue={
                  Ev.status === 1 || Ev.status === 2
                    ? Ev.submiterName
                    : loggedInUser.firstName + " " + loggedInUser.lastName
                }
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                id="outlined-read-only-input"
                label="date"
                defaultValue={moment(dateU).format("DD/MM/YYYY")}
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                label="haftara"
                defaultValue={haftara}
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                label="Nom du lecteur"
                className="uyu"
                InputProps={
                  Ev.status === 1
                    ? isManagerOrAdmin || loggedInUser._id === Ev.submiterId
                      ? { readOnly: false }
                      : {
                          readOnly: true,
                        }
                    : Ev.status === 2
                      ? isManagerOrAdmin
                        ? { readOnly: false }
                        : {
                            readOnly: true,
                          }
                      : {
                          readOnly: false,
                        }
                }
                onFocus={onChangeFocus}
                type="text"
                name="costumerLastName"
                onChange={onHandleInputChange}
                value={costumerLastName}
              />
              {!(Ev.status === 1) && !(Ev.status === 2) && (
                <Button
                  className="save-btn btn-simple animation-on-hover"
                  color="success"
                  variant="contained"
                  onClick={() => {
                    submit();
                  }}
                >
                  soumettre
                </Button>
              )}
              {Ev.status === 1 &&
                (isManagerOrAdmin || loggedInUser._id === Ev.submiterId) && (
                  <Button
                    className="save-btn btn-simple animation-on-hover"
                    color="danger"
                    variant="contained"
                    onClick={() => {
                      deleteU();
                    }}
                  >
                    supprimer
                  </Button>
                )}
              {Ev.status === 2 && isManagerOrAdmin && (
                <Button
                  className="save-btn btn-simple animation-on-hover"
                  color="success"
                  variant="contained"
                  onClick={() => {
                    accept();
                  }}
                >
                  accepter
                </Button>
              )}
              {Ev.status === 2 &&
                (isManagerOrAdmin || loggedInUser._id === Ev.submiterId) && (
                  <Button
                    className="save-btn btn-simple animation-on-hover"
                    color="danger"
                    variant="contained"
                    onClick={() => {
                      deleteU();
                    }}
                  >
                    supprimer
                  </Button>
                )}
            </div>
          ) : (
            <div>
              <p>
                <br></br>
              </p>
              <Button
                className="save-btn btn-simple animation-on-hover"
                color="success"
                variant="contained"
                onClick={() => {
                  setBol2(true);
                  setCostumerLastName(Ev.reader);
                  setCostumerDetails(Ev.details);
                }}
              >
                details
              </Button>
            </div>
          ))}

        {bol && openFlag === 2 && (
          <div>
            <p>
              <br></br>
            </p>

            {Evs.length > 0 && <h4>Demandes existantes</h4>}

            {Evs.length > 0 &&
              Evs.map((demande) => (
                <div
                  key={demande._id}
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    label="Demandeur"
                    defaultValue={demande.submiterName}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <TextField
                    label="date"
                    defaultValue={demande.date}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <TextField
                    label="parasha"
                    defaultValue={haftara}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <TextField
                    label="Nom du lecteur"
                    defaultValue={demande.reader}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <TextField
                    label="Montée"
                    defaultValue={demande.details}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <TextField
                    label="Statut"
                    defaultValue={getStatusLabel(demande.status)}
                    InputProps={{
                      readOnly: true,
                    }}
                  />

                  {demande.status === 2 && isManagerOrAdmin && (
                    <Button
                      className="save-btn btn-simple animation-on-hover"
                      color="success"
                      variant="contained"
                      onClick={() => {
                        accept(demande);
                      }}
                    >
                      accepter
                    </Button>
                  )}

                  {(isManagerOrAdmin ||
                    loggedInUser._id === demande.submiterId) && (
                    <Button
                      className="save-btn btn-simple animation-on-hover"
                      color="danger"
                      variant="contained"
                      onClick={() => {
                        deleteU(demande);
                      }}
                    >
                      supprimer
                    </Button>
                  )}
                </div>
              ))}

            {peutFaireDemandeParasha && (
              <div>
                <h4>Nouvelle demande de lecture</h4>

                <TextField
                  label="Nom du lecteur"
                  className="uyu"
                  onFocus={onChangeFocus}
                  type="text"
                  name="costumerLastName"
                  onChange={onHandleInputChange}
                  value={costumerLastName}
                />

                <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                  {["1", "2", "3", "4", "5", "6", "7"].map((montee) => (
                    <label key={montee} style={{ marginRight: "12px" }}>
                      <input
                        type="radio"
                        name="costumerDetails"
                        value={montee}
                        checked={costumerDetails === montee}
                        disabled={isMonteeDisabled(montee)}
                        onChange={onHandleInputChange}
                      />
                      {montee}
                    </label>
                  ))}

                  <label style={{ marginRight: "12px" }}>
                    <input
                      type="radio"
                      name="costumerDetails"
                      value="Tout"
                      checked={costumerDetails === "Tout"}
                      onChange={onHandleInputChange}
                    />
                    Tout (Bar Mitsvah)
                  </label>
                </div>

                <Button
                  className="save-btn btn-simple animation-on-hover"
                  color="success"
                  variant="contained"
                  onClick={() => {
                    submit();
                  }}
                >
                  soumettre
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
      <div>
        {openFlag === 1 && (
          <Calendar
            calendarType="Hebrew"
            maxDate={addMonths(new Date(), 6)}
            onChange={checkDate}
            value={dateU}
            tileContent={DateTile}
            tileClassName={defTileClassName}
            showFixedNumberOfWeeks
            showNeighboringMonth={true}
            formatShortWeekday={(locale, date) => date.toDateString()[0]}
          />
        )}
        {openFlag === 2 && (
          <Calendar
            calendarType="Hebrew"
            maxDate={addMonths(new Date(), 6)}
            onChange={checkDate}
            value={dateU}
            tileContent={DateTile}
            tileClassName={defTileClassName}
            showFixedNumberOfWeeks
            showNeighboringMonth={true}
            formatShortWeekday={(locale, date) => date.toDateString()[0]}
          />
        )}
      </div>
    </div>
  );
}

// const rootElement = document.getElementById("root");
// ReactDOM.render(<App />, rootElement);
